export const CORE_CUSTOMER_EDIT_ROLES = new Set([
  "administrator",
  "analytics-rep",
  "finance-rep",
]);

export const CUSTOMER_CONTACT_EDIT_ROLES = new Set(["client-rep", "order-rep", "finance-rep", "purchasing-rep"]);

export const normalizeCustomerEditRole = (role) =>
  String(role || "").trim().toLowerCase().replace(/_/g, "-").replace(/\s+/g, "-");

export const canEditCoreCustomerFields = (role) =>
  CORE_CUSTOMER_EDIT_ROLES.has(normalizeCustomerEditRole(role));

export const canEditCustomerContactFields = (role) =>
  canEditCoreCustomerFields(role) || CUSTOMER_CONTACT_EDIT_ROLES.has(normalizeCustomerEditRole(role));

export const canEditCustomerAssignments = (role) => {
  const normalizedRole = normalizeCustomerEditRole(role);
  return (
    ["administrator", "super-administrator"].includes(normalizedRole) ||
    normalizedRole === "analytics-rep" ||
    normalizedRole === "client-rep" ||
    normalizedRole === "order-rep" ||
    normalizedRole === "demo-user"
  );
};
